// Single source of truth for the Requests section's pages.
// Both the sidebar (what is shown) and the router in index.jsx (what is
// allowed to render) read from here, so their permission rules can't drift.

export const DEFAULT_PAGE = "view-requests";

export const NAV_GROUPS = [
  {
    label: "My work",
    items: [
      { key: "view-requests", label: "My Requests", icon: "fa-file-text-o", shortcut: "r" },
      { key: "view-forms", label: "Forms", icon: "fa-list-alt", shortcut: "f" },
    ],
  },
  {
    label: "Approvals",
    items: [
      { key: "view-approval-list", label: "Pending approval", icon: "fa-check-square-o", perm: "approval_page", shortcut: "a" },
      { key: "view-approve-history", label: "Approved by me", icon: "fa-history", perm: "approval_page" },
    ],
  },
  {
    label: "Tagging",
    items: [
      { key: "view-for-tagging", label: "For tagging", icon: "fa-tag", perm: "tagging_page", shortcut: "t" },
      { key: "view-approval-history", label: "Tagging history", icon: "fa-tags", perm: "tagging_page" },
    ],
  },
  {
    label: "Oversight",
    items: [
      { key: "view-reports", label: "Audit", icon: "fa-search", perm: "audit_page" },
      { key: "view-ccar", label: "CCAR history", icon: "fa-archive", perm: "ccar_page" },
    ],
  },
];

// Pages reachable by URL but not listed in the sidebar.
// `parent` decides which sidebar item stays highlighted.
export const HIDDEN_PAGES = {
  "view-request-detail": { parent: "view-requests", title: "Request details" },
  "new-request": { parent: "view-requests", title: "New request" },
  dashboard: { title: "Dashboard" },
};

const NAV_ITEMS = NAV_GROUPS.flatMap((group) => group.items);

export const pageHref = (key) => `/requests?p=${key}`;

export const isKnownPage = (key) =>
  NAV_ITEMS.some((item) => item.key === key) || key in HIDDEN_PAGES;

export const hasPagePermission = (key, permissions) => {
  const item = NAV_ITEMS.find((navItem) => navItem.key === key);
  if (!item?.perm) return true;
  return Boolean(permissions?.[item.perm]);
};

export const getNavItem = (key) => NAV_ITEMS.find((item) => item.key === key);

export const getActiveNavKey = (key) => HIDDEN_PAGES[key]?.parent || key;

export const getPageTitle = (key) =>
  getNavItem(key)?.label || HIDDEN_PAGES[key]?.title || "Requests";

export const getNavGroupOf = (key) =>
  NAV_GROUPS.find((group) => group.items.some((item) => item.key === key));

// Groups with the items this user may see; empty groups are dropped.
export const getVisibleGroups = (permissions) =>
  NAV_GROUPS.map((group) => ({
    ...group,
    items: group.items.filter((item) => hasPagePermission(item.key, permissions)),
  })).filter((group) => group.items.length > 0);
